<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'mda' | nomenclatura | async}}</ion-title>
  </ion-buttons>
</ion-header>


<ion-content>
  <div class="gradient-extendido"></div>

  <ion-grid class="gradient-container" style="margin-top: -49px;">
    <ion-row class="ion-justify-content-center" *ngIf="pessoa.id">
      <ion-col size="auto">
        <img [src]="pessoa.foto | image:' '" class="image" />
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center" *ngIf="pessoa.id">
      <ion-col size="auto">
        <p class="nome-pessoa bold-2">
          {{pessoa.id ? pessoa.nome : ("Nenhuma Pessoa Selecionada" |
          translate)}}
        </p>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center" *ngIf="!edit && pessoa.id">
      <ion-col size="10">
        <div>
          <ion-button class="btn-default" expand="block" (click)="selecionarPessoa();">
            {{'Alterar Pessoa' | translate}}
          </ion-button>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="ion-justify-content-center" *ngIf="!pessoa.id">
      <ion-col size="10">
        <div>
          <ion-button class="btn-default" expand="block" (click)="selecionarPessoa();">
            {{'Selecionar Pessoa' | translate}}
          </ion-button>
        </div>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col class="dados-vinculo">
        <i class="fas fa-clipboard-list div-icon"></i>

        <ion-label class="color-title">
          {{'Dados do Vinculo' | translate}}
        </ion-label>
      </ion-col>
    </ion-row>
  </ion-grid>

  <form [hidden]="!pessoa.id" class="sample-form validations-form" [formGroup]="validations_form"
    (ngSubmit)="onSubmit(validations_form.value)">
    <ion-grid>
      <ion-row>
        <ion-col size="12" class="remove-border">
          <ion-item lines="none">
            <ion-select labelPlacement="stacked" interface="action-sheet" placeholder="{{'Selecione' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}" okText="{{ 'Confirmar' | translate}}" formControlName="vinculo"
              [disabled]="edit" errorText="{{ 'O vinculo deve ser informado' | translate }}">
              <div slot="label" class="slot-label">
                {{'A pessoa selecionada é' | translate}}
                <ion-text color="danger" *ngIf="validations_form.get('vinculo')?.hasError('required')">*</ion-text>
              </div>

              <ion-select-option *ngFor="let item of tipoVinculoList"
                [value]="item.id">{{item.nome}}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12" class="remove-border">
          <ion-item lines="none">
            <ion-select labelPlacement="stacked" interface="action-sheet" placeholder="{{'Selecione' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}" okText="{{ 'Confirmar' | translate}}" formControlName="idMdaTipo"
              (ionChange)="mudarTipo($event);">
              <div slot="label" class="slot-label">
                {{'Tipo Padrão' | translate}}
              </div>

              <ion-select-option *ngFor="let item of tipoList" [value]="item.id">{{item.nome}}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ion-row>

      <ng-container>
        <div style="margin: 0 8px 0 4px;">
          <prover-datepicker
            [labelName]="'Desde'"
            [id]="'data'" 
            formControlName="data" 
            [required]="true"
            [isDataAtual]="true"
          ></prover-datepicker>
          <div class="validation-errors">
            <ng-container *ngFor="let validation of validation_messages.data">
              <div class="error-message"
                *ngIf="validations_form.get('data')?.hasError(validation.type) && (validations_form.get('data')?.dirty || validations_form.get('data')?.touched)">
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ion-row>
        <ion-col size="12" class="remove-border">
          <ion-item lines="none">
            <ion-textarea labelPlacement="stacked" rows="3" formControlName="observacao"
              placeholder="{{'Digite sua Observação' | translate}}">
              <div slot="label" class="slot-label">
                {{'Observação' | translate}}
              </div>
            </ion-textarea>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid *ngIf="tipoSelecionado.hasHorario == '1'">
      <ion-row>
        <ion-col class="dados-vinculo">
          <i class="fas fa-clipboard-list div-icon"></i>

          <ion-label class="color-title">
            {{'Horário de Funcionamento' | translate}}
          </ion-label>
        </ion-col>
      </ion-row>

      <ng-container>
        <div style="margin: 0 8px 0 4px;">
          <app-prover-horas
            [labelName]="'Hora Início'"
            [id]="'horarioInicio'"
            formControlName="horarioInicio"
            [required]="true"
            [isLabel]="true"
          ></app-prover-horas>
          <div class="validation-errors">
            <ng-container *ngFor="let validation of validation_messages.horarioInicio">
              <div class="error-message"
                *ngIf="validations_form.get('horarioInicio')?.hasError(validation.type) && (validations_form.get('horarioInicio')?.dirty || validations_form.get('horarioInicio')?.touched)">
                {{ validation.message }}
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <ion-row>
        <ion-col size="12" class="remove-border">
          <ion-item lines="none">
            <ion-select labelPlacement="stacked" interface="action-sheet" placeholder="{{'Selecione' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}" okText="{{ 'Confirmar' | translate}}" formControlName="diaSemana"
              [disabled]="edit" errorText="{{ 'O Dia da Semana deve ser informado' | translate }}">
              <div slot="label" class="slot-label">
                {{'Dia da Semana' | translate}}
                <ion-text color="danger" *ngIf="validations_form.get('diaSemana')?.hasError('required')">*</ion-text>
              </div>

              <ion-select-option *ngFor="let item of diaSemanaList" [value]="item.id">{{item.nome}}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col size="12" class="remove-border">
          <ion-item lines="none">
            <ion-select labelPlacement="stacked" interface="action-sheet" placeholder="{{'Selecione' | translate}}"
              cancelText="{{ 'Cancelar' | translate}}" okText="{{ 'Confirmar' | translate}}"
              formControlName="frequenciaDias" [disabled]="edit" errorText="{{ 'Campo Obrigatório' | translate }}">
              <div slot="label" class="slot-label">
                {{'Acontece a Cada' | translate}}

                <ion-text color="danger"
                  *ngIf="validations_form.get('frequenciaDias')?.hasError('required')">*</ion-text>
              </div>

              <ion-select-option *ngFor="let item of frequenciaDiasList"
                [value]="item.id">{{item.nome}}</ion-select-option>
            </ion-select>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-grid>
      <ion-row class="ion-justify-content-center">
        <ion-col size="9">
          <ion-button expand="block" class="btn-success" type="submit"
            [disabled]="!validations_form.valid || !pessoa.id">
            {{'Salvar' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-content>